/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // document.getElementById("ws-body").style.overflow = "hidden";
  }
  // removing scroll hiding part due to flicker issue.
  // ngOnDestroy(): void {
  //   document.getElementById("ws-body").style.overflow = "auto";
  // }
}
